import React, { useState } from "react";
import { fileUrl } from "@/lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ImageGallery({ photos = [], name = "" }) {
  const [index, setIndex] = useState(0);
  if (!photos || photos.length === 0) {
    return (
      <div className="aspect-square bg-[#FAF7F0] border border-black/5 flex items-center justify-center text-[#B8860B]/40 text-6xl font-display">
        ✟
      </div>
    );
  }
  const photo = photos[index];
  const prev = () => setIndex((i) => (i - 1 + photos.length) % photos.length);
  const next = () => setIndex((i) => (i + 1) % photos.length);

  return (
    <div className="space-y-4" data-testid="product-image-gallery">
      <div className="aspect-square relative bg-[#FAF7F0] border border-black/5 overflow-hidden">
        <img
          src={fileUrl(photo.path)}
          alt={`${name} ${index + 1}`}
          className="w-full h-full object-cover"
        />
        {photos.length > 1 && (
          <>
            <button
              onClick={prev}
              className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/60 border border-[#B8860B]/40 p-2 text-[#B8860B] hover:bg-[#B8860B] hover:text-black transition"
              data-testid="gallery-prev"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              onClick={next}
              className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/60 border border-[#B8860B]/40 p-2 text-[#B8860B] hover:bg-[#B8860B] hover:text-black transition"
              data-testid="gallery-next"
            >
              <ChevronRight size={18} />
            </button>
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
              {photos.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`h-1.5 transition-all ${i === index ? "w-8 bg-[#B8860B]" : "w-3 bg-white/30"}`}
                  aria-label={`Image ${i + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {photos.length > 1 && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar">
          {photos.map((p, i) => (
            <button
              key={p.id || i}
              onClick={() => setIndex(i)}
              className={`flex-shrink-0 w-20 h-20 border ${i === index ? "border-[#B8860B]" : "border-black/10"}`}
            >
              <img src={fileUrl(p.path)} alt={`thumb ${i}`} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
